import type { ComponentProps } from "@blocknote/react";
import classNames from "classnames";
import type { MouseEvent } from "react";
import { bgStyles, borderStyles, flexStyles, heightStyles, pointerStyles, squareStyles } from "ui";
import styles from "../Popover/Root.module.css";

type Props = ComponentProps["LinkToolbar"]["Button"];
export function Button({ children, icon, onClick, className, mainTooltip }: Props) {
  const hasIcon = !!icon;
  const localOnClick =
    onClick ||
    ((e: MouseEvent<HTMLButtonElement>) => {
      e.currentTarget.parentElement?.classList.add(styles.opened);
    });
  return (
    <button
      className={classNames(
        bgStyles.neutral200,
        flexStyles.horiz,
        flexStyles.justifyCenter,
        flexStyles.alignCenter,
        borderStyles.neutral400,
        borderStyles.radius025,
        pointerStyles.cursor,
        { [squareStyles.square200]: hasIcon },
        { [heightStyles.height200]: !hasIcon },
        className,
      )}
      type="button"
      onClick={localOnClick}
      title={mainTooltip}
    >
      {icon}
      {children}
    </button>
  );
}
